import styled from "styled-components";

interface StyledProps {
  fontScaling?: string;
}

const ItemFontScaling = styled.div<StyledProps>`
  /* math {
    display: none !important;
  } */
  math {
    opacity: 0;
  }
  .MathJax_Preview {
    opacity: 0;
  }
  .MathJax_SVG {
    outline: none;
  }

  font-size: ${(props) =>
    props?.fontScaling ? `${props?.fontScaling}em` : "1em"};
`;

export default ItemFontScaling;
